import API from "../../API";
import { showToast } from "../../Controllers/Toast";
import { APPLY_DISCOUNT, GET_ALL_DISCOUNT, GET_TRANSACTION, GET_TRANSACTION_ANALYTICS, GET_TRANSACTION_FAILED, GET_TRANSACTION_REQUEST, HANDLE_ERROR, PLACE_ORDER, PLACE_ORDER_FAILED, PLACE_ORDER_REQUEST, RETURN_PRODUCT, RETURN_PRODUCT_FAILED, RETURN_PRODUCT_REQUEST, SEND_INVOICE, SEND_INVOICE_FAILED, SEND_INVOICE_REQUEST } from "../action.type";
import { addToCartProduct } from "./catelog.action";

export const getAllDiscount = (pos_customer, products, categories ) => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: '/admin/pos/viewDiscount', method: 'post', data: {pos_customer, products, categories }})
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                dispatch({
                    type: GET_ALL_DISCOUNT,
                    payload: apiCall?.data,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const applyDiscount = (customer, coupon) => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: 'admin/pos/applyDiscount', method: 'get', params: {pos_customer: customer, coupon_code: coupon}})
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                showToast.success("Coupon applyed successfully!")
                dispatch({
                    type: APPLY_DISCOUNT,
                    payload: apiCall?.data,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const removeDiscount = () => {
    return async (dispatch) => {
        dispatch({
            type: APPLY_DISCOUNT,
            payload: null,
        });
    };
};
export const placeOrder = (data) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: PLACE_ORDER_REQUEST,
                payload: true,
            });
            const apiCall = await API({ url: '/admin/pos/placeOrder', method: 'post', data: data})
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                showToast.success(data?.status === 'pending' ? "Order pending successfully!" : "Order placed successfully!")
                const cart= {
                    products: [],
                    status: 'completed',
                    channel: 'pos',
                    total_price: 0,
                    sub_total: 0,
                  };
                localStorage.setItem('addToCart', JSON.stringify(cart));
                dispatch(addToCartProduct(cart));
                dispatch(getTransactions('pending'));
                dispatch({
                    type: PLACE_ORDER,
                    payload: apiCall?.data,
                });
                dispatch(removeDiscount());
            }
        } catch (error) {
            dispatch({
                type: PLACE_ORDER_FAILED,
                payload: false,
            });
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const getTransactions = (status, page, limit, searchkey, sort_by, order_by, sort, customerId) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: GET_TRANSACTION_REQUEST,
            });
            const apiCall = await API({ url: '/admin/pos/getTransactions', method: 'get', params: { page, limit, searchkey, sort_by, order_by, sort, status, customer_id: customerId }})
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                dispatch({
                    type: GET_TRANSACTION,
                    payload: apiCall?.data,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
            dispatch({
                type: GET_TRANSACTION_FAILED,
            });
        }
    };
};
export const getTransactionAnalytics = (sort) => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: '/admin/pos/transactionanalytics', method: 'get', params: { sort }})
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                dispatch({
                    type: GET_TRANSACTION_ANALYTICS,
                    payload: apiCall?.data,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const addDiscount = (data) => {
    return async (dispatch) => {
        dispatch({
            type: APPLY_DISCOUNT,
            payload: data,
        });
    };
};
export const removeOrderInfo = () => {
    return async (dispatch) => {
        dispatch({
            type: PLACE_ORDER,
            payload: null,
        });
    };
};
export const sendInvoice = (id, type) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: SEND_INVOICE_REQUEST,
                payload: null,
            });
            const apiCall = await API({ url: `admin/pos/sendInvoice/${id}`, method: 'post', params: {type: type}})
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                showToast.success("Send Invoice successfully!")
                dispatch({
                    type: SEND_INVOICE,
                    payload: apiCall?.data,
                });
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: SEND_INVOICE_FAILED,
                payload: null,
            });
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const returnOrder = (data) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: RETURN_PRODUCT_REQUEST,
                payload: null,
            });
            const apiCall = await API({ url: `admin/pos/returnOrder`, method: 'post', data })
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                showToast.success("Return Product successfully!")
                dispatch({
                    type: RETURN_PRODUCT,
                    payload: apiCall?.data,
                });
                dispatch(getTransactions('', 1, 25, '', '', 'DESC', 'All'));
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: RETURN_PRODUCT_FAILED,
                payload: null,
            });
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};
export const deletePendingOrder = (id) => {
    return async (dispatch) => {
        try {
            const apiCall = await API({ url: `admin/pos/deletePendingOrder`, method: 'delete', data: {order_id: id} })
            if (apiCall?.status === 200 || apiCall?.status === 304) {
                showToast.success("Pending order remove successfully!")
                dispatch(getTransactions('pending', 1, 25, '', '', 'DESC', 'All'));
            }
        } catch (error) {
            showToast.error(error)
            dispatch({
                type: HANDLE_ERROR,
                payload: error,
            });
        }
    };
};